/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Agent_Not_FoundInputs */

const cs_public_site_agent_not_found = /** @type {(inputs: Public_Site_Agent_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil makléře nebyl nalezen.`)
};

const en_public_site_agent_not_found = /** @type {(inputs: Public_Site_Agent_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent profile not found.`)
};

/**
* | output |
* | --- |
* | "Agent profile not found." |
*
* @param {Public_Site_Agent_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_agent_not_found = /** @type {((inputs?: Public_Site_Agent_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Agent_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_agent_not_found(inputs)
	return cs_public_site_agent_not_found(inputs)
});